<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="page-title">Modelos de Permissões</h2>
                <p class="page-subtitle">Configurações de acesso para diferentes perfis de utilizadores</p>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">
            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            {{ item?.Name }}
                            <ion-badge [color]="getRoleColor(item?.UserRole?.Id)">
                                {{ item?.UserRole?.Name }}
                            </ion-badge>
                            <ion-badge *ngIf="item?.IsMain" color="primary">Principal</ion-badge>
                            <ion-badge *ngIf="item?.IsPublic" color="success">Público</ion-badge>
                        </ion-card-title>
                        <ion-card-subtitle *ngIf="item?.Description">
                            {{ item?.Description | slice:0:100 }}{{ item?.Description.length > 100 ? '...' : '' }}
                        </ion-card-subtitle>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="information-circle-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">ID</span>
                                    <span class="detail-value">{{ item?.Id }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado em</span>
                                    <span class="detail-value">{{ item?.CreateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado por</span>
                                    <span class="detail-value">{{ item?.CreateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid" *ngIf="item?.UpdateDate">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Atualizado em</span>
                                    <span class="detail-value">{{ item?.UpdateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Atualizado por</span>
                                    <span class="detail-value">{{ item?.UpdateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Papel do Utilizador -->
                        <ion-item-divider>
                            <ion-label>Papel do Utilizador</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="people-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Perfil</span>
                                    <span class="detail-value">{{ item?.UserRole?.Name }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="id-card-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">ID do Perfil</span>
                                    <span class="detail-value">{{ item?.UserRole?.Id }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Descrição Completa -->
                        <ng-container *ngIf="item?.Description">
                            <ion-item-divider>
                                <ion-label>Descrição</ion-label>
                            </ion-item-divider>

                            <div class="detail-grid single-col">
                                <div class="detail-item">
                                    <ion-icon name="document-text-outline"></ion-icon>
                                    <div class="detail-text">
                                        <div class="description-content">{{ item?.Description }}</div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Configurações de Visibilidade -->
                        <ion-item-divider>
                            <ion-label>Configurações de Visibilidade</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.IsMain ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.IsMain"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Perfil Principal</span>
                                    <span class="detail-value">{{ item?.IsMain ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.IsPublic ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.IsPublic"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Perfil Público</span>
                                    <span class="detail-value">{{ item?.IsPublic ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-col>
